<template>
  <div class="friendship">
    <div class="title">
      友情链接
    </div>
    <div class="rank_items">

    </div>
  </div>
</template>

<script>
  export default{
    name:'Friendship'
  }
</script>

<style lang="scss">
  .friendship{
    background-color: #fff;
    // padding: 20px 0px;
    height: 60px;
    line-height: 60px;
    border-radius: 12px;
    .title{
      text-align: left;
      font-weight: 700;
      font-size: 20px;
      padding-left: 40px;
      border-bottom: 1px solid #ccc;
    }
    .rank_items{

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/firstPage/components/friendship.vue